<template>
  <h1 data-testid="homepage-title" class="title px-4 sm:p-0" v-if="flow !== 'mainsite'">
    Car Service<br v-if="!isAgency" />{{ isAgency ? ' - Agency Area' : 'with Private Driver' }}
  </h1>
  <div
    class="contact_form_wrapper px-4 pt-6"
    :class="[
      flow !== 'mainsite' ? '!mt-6 !bg-opacity-50 md:!mt-[48px]' : '!m-0 !bg-opacity-80',
      isAgency ? '!px-0 !pb-0' : ''
    ]"
  >
    <div class="w-full">
      <span :class="isAgency ? 'px-8' : 'px-0'" class="summary_title home_form__title"
        >Choose Type of Service</span
      >
      <div
        :class="isAgency ? 'px-8' : 'px-0'"
        class="relative w-full overflow-x-auto pb-[2px] [-ms-overflow-style:_none] [scrollbar-width:_none] sm:w-max [&::-webkit-scrollbar]:hidden"
      >
        <div class="home_form__toggler w-max">
          <button
            v-for="(button, index) in buttons"
            @click="changeForm(button)"
            :key="index"
            :class="{ ...button.class, active: button.active }"
          >
            {{ button.name }}
          </button>
        </div>
      </div>
      <OneWayTransferForm v-if="formActive === 1 && !isAgency" :handleKeyDown="handleKeyDown" />
      <OneWayTransferFormForAgency
        v-if="formActive === 1 && isAgency"
        :handleKeyDown="handleKeyDown"
      />
      <HourlyAsDirectedForm v-if="formActive === 2 && !isAgency" />
      <HourlyAsDirectedFormForAgency v-if="formActive === 2 && isAgency" />
      <ToursForm v-if="formActive === 3 && !isAgency" :handleKeyDown="handleKeyDown" />
      <ToursFormForAgency v-if="formActive === 3 && isAgency" :handleKeyDown="handleKeyDown" />
      <p
        v-if="flow !== 'mainsite'"
        class="privacy_text home_form__text mt-4 pb-[15px] text-center sm:hidden"
      >
        For multiple rides/days service
        <span @click="stayWithUsModalStore.show" class="text-main cursor-pointer">click here</span
        >.<br />For Agency requests add your IATA or License Code in the notes
      </p>
    </div>
  </div>
  <p
    v-if="flow !== 'mainsite'"
    class="privacy_text home_form__text mt-[118px] hidden text-center sm:block"
  >
    For multiple rides/days service
    <span @click="stayWithUsModalStore.show" class="text-main cursor-pointer">click here</span
    >.<br />For Agency requests add your IATA or License Code in the notes
  </p>
</template>
<script setup>
import { reactive, ref, onBeforeMount, onMounted, watch, computed } from 'vue'
import '@vuepic/vue-datepicker/dist/main.css'
import { useMainStore } from '@/stores'
import { useOrderStore } from '@/stores/ride/order'
import { storeToRefs } from 'pinia'
import { useUserStore } from '@/stores/user'
import ToursFormForAgency from '@/components/ui/forms/ToursFormForAgency.vue'
import ToursForm from '@/components/ui/forms/ToursForm.vue'
import HourlyAsDirectedFormForAgency from '@/components/ui/forms/HourlyAsDirectedFormForAgency.vue'
import HourlyAsDirectedForm from '@/components/ui/forms/HourlyAsDirectedForm.vue'
import OneWayTransferFormForAgency from '@/components/ui/forms/OneWayTransferFormForAgency.vue'
import OneWayTransferForm from '@/components/ui/forms/OneWayTransferForm.vue'
import { useStayWithUsModalStore } from '@/stores/ui/stayWithUsModal'

const stayWithUsModalStore = useStayWithUsModalStore()

const orderStore = useOrderStore()
const userStore = useUserStore()

const { orderType } = storeToRefs(orderStore)
const { user } = storeToRefs(userStore)

const mainStore = useMainStore()
const { flow } = storeToRefs(mainStore)
const buttons = reactive([
  {
    class: { 'home_form__button button mr-2': true },
    active: true,
    name: 'One Way Transfer',
    index: 1
  },
  {
    class: { 'home_form__button button mr-2': true },
    active: false,
    name: 'Hourly as directed',
    index: 2
  }
])

if (import.meta.env.VITE_PROJECT_ALIAS !== 'rlt') {
  buttons.push({
    class: { 'home_form__button button': true },
    active: false,
    name: 'Tours/Roadshows',
    index: 3
  })
}
const isAgency = computed(() => {
  if (!user?.value) {
    return false
  } else {
    return user?.value.type === 'agency'
  }
})
const formActive = ref(1)
const changeForm = (button = false, index = false) => {
  if (button && !index) {
    if (!button.active) {
      buttons.forEach((el) => {
        el.active = false
      })
      button.active = true
      formActive.value = button.index
      switch (formActive.value) {
        case 1:
          orderStore.orderData.type_of_service = 'oneWayTransfer'
          break
        case 2:
          orderStore.orderData.type_of_service = 'hourlyAsDirected'
          break
        case 3:
          orderStore.orderData.type_of_service = 'toursRoadshows'
          break
      }
    }
  }
  if (!button && index) {
    buttons.forEach((el) => {
      el.active = false
    })
    buttons[index - 1].active = true
    formActive.value = index
    switch (formActive.value) {
      case 1:
        orderStore.orderData.type_of_service = 'oneWayTransfer'
        break
      case 2:
        orderStore.orderData.type_of_service = 'hourlyAsDirected'
        break
      case 3:
        orderStore.orderData.type_of_service = 'toursRoadshows'
        break
    }
  }
}
let isInitialRun = true
watch(formActive, (newVal, oldVal) => {
  if (isInitialRun) {
    isInitialRun = false
    return
  }
  if (orderType.value === 'DUPLICATE' && newVal !== oldVal) {
    orderStore.changeTypeOrder('NEW')
  }
})

// Determine next input and move focus to it
const focusNextInput = () => {
  const inputs = Array.from(document.querySelectorAll('.home_form input:not(.dp__input)'))
  const focusedInputIndex = inputs.indexOf(document.activeElement)

  if (focusedInputIndex !== -1) {
    const nextIndex = focusedInputIndex + 1
    if (nextIndex < inputs.length) {
      inputs[nextIndex].focus()
    } else {
      document.activeElement.blur()
    }
  }
}

const handleKeyDown = (event) => {
  if (event.key === 'Enter') {
    event.preventDefault()
    focusNextInput()
  }
}

onMounted(() => {
  if (flow.value === 'mainsite') {
    document.body.classList.add('!bg-transparent', '!p-0')
  }
})

onBeforeMount(() => {
  // Clear Timer in Payment
  if (orderStore.orderData.type_of_service === 'oneWayTransfer') changeForm(false, 1)
  if (orderStore.orderData.type_of_service === 'hourlyAsDirected') changeForm(false, 2)
  if (orderStore.orderData.type_of_service === 'toursRoadshows') changeForm(false, 3)

  orderStore.update({
    countdown: 'stop'
  })
  if (!user.value || !orderStore.duplicatedOrder) {
    orderStore.changeTypeOrder('NEW')
  }
})
</script>
